import type { UserProfile } from "../types";

export function addActivityAuthors<T extends { created_by: string }>(
  activities: readonly T[],
  profiles: readonly UserProfile[],
): Array<T & { author: UserProfile }> {
  const profilesById = new Map(profiles.map((profile) => [profile.user_id, profile]));

  return activities.map((activity) => ({
    ...activity,
    author: profilesById.get(activity.created_by) ?? {
      user_id: activity.created_by,
      display_name: "Unknown team member",
    },
  }));
}
